import type { IncidenceTypesRepositoryT } from "../../domain/ports/incidenceTypes.repository";
import type {
  IncidenceTypesApiT,
  IncidenceTypesMapperT,
} from "../types/incidenceTypes.types";

import { extractErrorMessage } from "../../../utils/extractErrorMessage";

type IncidenceTypesRepositoryParamsT = {
  incidenceTypesApi: IncidenceTypesApiT;
  incidenceTypesMapper: IncidenceTypesMapperT;
};

export const createIncidenceTypesRepository = ({
  incidenceTypesApi,
  incidenceTypesMapper,
}: IncidenceTypesRepositoryParamsT): IncidenceTypesRepositoryT => ({
  getAll: async () => {
    try {
      const response = await incidenceTypesApi.getAll();

      if (response.status !== 200) {
        throw new Error("Ocurrió un error al obtener los tipos de incidencia");
      }

      return incidenceTypesMapper.incidenceTypesDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al obtener los tipos de incidencia",
      );

      throw new Error(message);
    }
  },
});
